import React, {useEffect} from 'react';
import { Typography } from '@material-ui/core';
import './ThankYou.css';

export default function ThankYou ({postFeedback} : any) {
    const message = (postFeedback.code == "200") ? 'Thank you!' : `Form was not submitted. Error: ${postFeedback.message}`;
    return(
        <div>
            <img src="https://storage.googleapis.com/static.bit.dev/lp-assets/meerkat_full.jpg" alt="Full Meerkat" />
            <Typography variant="h6" component="h6" style={{color: '#756d6a'}}>{message}</Typography>
        </div>
    )
}